import {
  useCancelBulkTicketSaleBatchMutation,
  useCreateBulkTicketSaleBatchMutation,
  useGetBulkTicketSaleBatchesQuery,
  useGetSingleBulkTicketSaleQuery
} from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'

export function useBulkTicketSaleDrawerFunctions(selectedBulkTicketSaleId: string | undefined) {
  const { data: selectedBulkTicketSale, isFetching } = useGetSingleBulkTicketSaleQuery(
    selectedBulkTicketSaleId ?? '',
    { skip: !selectedBulkTicketSaleId }
  )
  const { data: batches } = useGetBulkTicketSaleBatchesQuery(selectedBulkTicketSaleId ?? '', {
    skip: !selectedBulkTicketSaleId
  })
  const [cancelBulkTicketSaleBatch] = useCancelBulkTicketSaleBatchMutation()
  const [createBulkTicketSaleBatch, { isLoading: isCreateLoading }] =
    useCreateBulkTicketSaleBatchMutation()

  return {
    selectedBulkTicketSale,
    isFetching,
    batches,
    cancelBulkTicketSaleBatch,
    createBulkTicketSaleBatch,
    isCreateLoading
  }
}
